import type { Application } from '../../../types';
import type { ClosingPackageProjection } from '../types';
import { closingPackageWorkflowStateMeta } from './workflowLabels';

export type ClosingPackageTaskModalContextView = {
  applicationNumber: string;
  clientName: string;
  routeSummary: string;
  packageSummary: string;
};

function formatApplicationNumber(
  application: Application | null | undefined,
  applicationId: number
): string {
  if (!application) {
    return `#${applicationId}`;
  }
  const number = application.internalNumber || application.externalNumber;
  return number ? `#${application.id} — ${number}` : `#${application.id}`;
}

export function formatApplicationRouteSummary(application: Application | null | undefined): string {
  const links = application?.routes ?? [];
  if (links.length === 0) {
    return '—';
  }

  return links
    .map((link) => {
      const route = link.route;
      if (!route) {
        return `Маршрут #${link.routeId}`;
      }
      const from = route.loadingCity ?? route.loadingAddress ?? '—';
      const to = route.unloadingCity ?? route.unloadingAddress ?? '—';
      return `${from} → ${to} (#${route.id})`;
    })
    .join('; ');
}

export function buildClosingPackageTaskModalContextView(input: {
  applicationId: number;
  application: Application | null | undefined;
  projection: ClosingPackageProjection | null | undefined;
}): ClosingPackageTaskModalContextView {
  const workflowMeta = input.projection
    ? closingPackageWorkflowStateMeta(input.projection.workflowState)
    : null;

  const packageSummary = input.projection
    ? `${workflowMeta?.label ?? input.projection.workflowState} · ${input.projection.compositionMode} · ${input.projection.compositionItemCount} поз.`
    : '—';

  return {
    applicationNumber: formatApplicationNumber(input.application, input.applicationId),
    clientName: input.application?.client?.name?.trim() || '—',
    routeSummary: formatApplicationRouteSummary(input.application),
    packageSummary,
  };
}
